// DEPRECATED

const blackFridayTicker = {
	context: {},
	tests: [
		() => {
			// test_A: nuthink
		},
		() => {
			// test_B:  timer under masthead
			const $ = jQuery;
			// get the navigation
			const $navigationElement = $("#masthead");

			// append the timer html
			$navigationElement.append(`
				<div class="black-friday-timer oswald bg-black text-white w-100 text-center h2 py-3 mb-0" style="letter-spacing: 3px;">
					<span class="d-inline-block text-end timer-days"> </span>:<span class="d-inline-block text-center timer-hours"></span>:<span class="d-inline-block text-center timer-minutes"></span>:<span class="d-inline-block text-center timer-seconds"></span>
				</div>
			`);

			const setupTimer = () => {
				$timerDays = $(".black-friday-timer .timer-days");
				$timerHours = $(".black-friday-timer .timer-hours");
				$timerMinutes = $(".black-friday-timer .timer-minutes");
				$timerSeconds = $(".black-friday-timer .timer-seconds");

				const eventDate = new Date("2022-11-28T23:59:00");
				const timerUpdate = () => {
					let currentDate = new Date();
					let timeDiffMs = eventDate - currentDate;
					let timeDiff = Math.floor(timeDiffMs * 0.001);

					const daysString = Math.floor(timeDiff / (60 * 60 * 24));
					const hoursString = ((Math.floor(timeDiff / 3600) % 24) + "").padStart(2, "0");
					const minutesString = ((Math.floor(timeDiff / 60) % 60) + "").padStart(2, "0");
					const secondsString = ((timeDiff % 60) + "").padStart(2, "0");

					$timerDays.html(daysString);
					$timerHours.html(hoursString);
					$timerMinutes.html(minutesString);
					$timerSeconds.html(secondsString);
					window.requestAnimationFrame(timerUpdate);
				};

				timerUpdate();
			};

			// call the setup after the HTML prepend is finished
			setTimeout(setupTimer, 0);
		},
	],
	canBeEnabled: () => {
		const eventStartDate = window.location.href.includes("shop.loveli.care")
			? new Date("2022-11-23T08:00:00")
			: new Date("2022-10-23T08:00:00");

		const now = new Date();
		const isEventStarted = now > eventStartDate;

		const isDiscountActiveAndTargetElementAvailable =
			!!document.querySelector(".loveli-discount-enabled") && !!document.querySelector("#masthead");
		const isNotCheckout = !window.location.href.includes("checkout");
		const isNotThankYou = !window.location.href.includes("order-received");
		const isHome = document.querySelector("body.home") || false;
		// return isEventStarted && isDiscountActiveAndTargetElementAvailable && isNotCheckout && isNotThankYou;
		return isEventStarted && isHome && isDiscountActiveAndTargetElementAvailable;
	},
};

export default blackFridayTicker;
